import GenericTouchable from './GenericTouchable';
import React from 'react';

var TouchableWithoutFeedback = function TouchableWithoutFeedback(props) {
  return React.createElement(GenericTouchable, props);
};

TouchableWithoutFeedback.defaultProps = GenericTouchable.defaultProps;
TouchableWithoutFeedback.propTypes = GenericTouchable.publicPropTypes;
export default TouchableWithoutFeedback;